import SkillUnit from "./SkillUnit"
import classes from "./Skills.module.css"
const SkillSet=[
    {skillname:"NodeJs",
    percent:"80"},
    {skillname:"React",
    percent:"85"},
    {skillname:"NextJs",
    percent:"60"},
    {skillname:"Java",
    percent:"80"},
    {skillname:"MongoDb",
    percent:"70"},
    // {skillname:"CSS",
    // percent:"90"},
    {skillname:"Python",
    percent:"65"},
    

]
const Skills=()=>{
    return(
        <>
        <div className={classes.mainContainer}>
            
            <div className={classes.titleContainer}>
            <div className={classes.circleShape}></div>
            <div className={classes.leftBar}></div>
            <div className={classes.title}>Skills</div>
            <div className={classes.rightBar}></div>
            <div className={classes.circleShape}></div>
            </div>
            
            <div className={classes.sectionContainer}>
               {SkillSet.map((item,index)=>{
                return <SkillUnit key={index} skillname={item.skillname} skillPercent={item.percent} />
               })}              
            </div>
       
          
        </div>
     
        </>
    )
}
export default Skills